<template>
  <!--   
  <nav id="nav">
    <router-link to="/">Home</router-link> |
    <router-link to="/random">Random</router-link>
  </nav> 
  -->
  <nav id="nav" :class="{ darken }">
    <div @click="open = !open" class="hamburger" :class="{ open, whiteHamburger }">
      <i class="fas fa-bars" :class="{ 'fa-times':open }"></i>
    </div>
    <ul class="nav-links" :class="{ open }">
      <li class="dave-menu-logo">
        <a href="/" @click="open = false" class="hvr-bob"><img src="../assets/dave-menu-logo.svg" alt="Dave" /></a>
      </li>
      <li>
        <a href="#about" @click="open = false" class="hvr-bob">About Dave</a>
      </li>
      <li>
        <a href="#portfolio" @click="open = false" class="hvr-bob">Dave's Work</a>
      </li>
      <li>
        <a href="#contact" @click="open = false" class="hvr-bob">Contact Dave</a>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: "Navbar",
  data() {
    return {
      open: false,
      darken: false,
      whiteHamburger: false,
      windowDimensions: {
        windowHeight: window.innerHeight,
        windowWidth: window.innerWidth
      }
    };
  },
  methods: {
    handleResize() {
      this.windowDimensions.windowHeight = window.innerHeight;
      this.windowDimensions.windowWidth = window.innerWidth;
    },
    handleScroll() {
      // this.darken = window.scrollY > this.windowDimensions.windowHeight;
      if (
        window.scrollY > this.windowDimensions.windowHeight - 150 &&
        this.windowDimensions.windowWidth > 768
      ) {
        this.darken = true;
      } else if (
        window.scrollY > this.windowDimensions.windowHeight - 100 &&
        this.windowDimensions.windowWidth <= 768
      ) {
        this.whiteHamburger = true;
      } else {
        this.darken = false;
        this.whiteHamburger = false;
      }
    }
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
    window.removeEventListener("scroll", this.handleScroll);
  }
};
</script>

<style scoped lang="scss">
// MAIN NAV
nav {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1000;
  // font-family: "Oswald", sans-serif !important;
  font-size: 2rem;
  transition-property: background-color;
  transition-duration: 0.4s;
  ul.nav-links {
    padding: 0 25px;
    display: flex;
    justify-content: flex-end;
    li {
      a {
        display: block;
        color: $dark-grey;
        text-decoration: none;
        padding: 20px 25px;
        align-items: center;
        transition-property: color;
        transition-duration: 1s;
        font-family: "Oswald", sans-serif;
        &:hover {
          color: $almost-black;
        }
      }
      &.dave-menu-logo {
        display: none;
      }
    }
  }
  &.darken {
    // background: $almost-black;
    background: rgba($almost-black, 0.88);
    box-shadow: 0px 5px 5px 0px rgba(0, 0, 0, 0.2);
    ul.nav-links {
      li {
        a {
          &:hover,
          &:focus {
            color: white;
          }
        }
        &.dave-menu-logo {
          display: flex;
          margin-right: auto;
          animation: logoFade 1s ease-in forwards;
          a {
            display: flex;
            padding: 0;
            img {
              height: 35px;
            }
          }
        }
      }
    }
  }
  .hamburger {
    display: none;
    position: absolute;
    right: 25px;
    top: 10px;
    font-size: 2.5rem;
    color: $dark-grey;
    cursor: pointer;
    &.whiteHamburger .fas {
      color: white;
    }
  }
}

@keyframes logoFade {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

// MOBILE/TABLET MENU
@media (max-width: 768px) {
  nav {
    ul.nav-links {
      .dave-menu-logo {
        display: block !important;
        padding-bottom: 20px;
        a {
          padding: 0;
          img {
            max-width: 33%;
            margin: 50px auto 0 auto;
            @include phone-down {
              max-width: 50%;
            }
          }
        }
      }
      height: 0;
      width: 100%;
      flex-direction: column;
      justify-content: flex-start;
      text-align: center;
      background: $almost-black;
      transition: all 0.25s ease-out;
      clip-path: circle(0px at 100% 0%);
      pointer-events: none;
      &.open {
        height: 100vh;
        clip-path: circle(100% at 100% 0%);
        pointer-events: all;
      }
      li {
        a {
          padding: 40px;
          color: white;
        }
      }
    }
    .hamburger {
      display: block;
      z-index: 1200;
      @include phone-down {
        right: 15px;
        top: 2px;
      }
      .fas {
        transition-property: background-color;
        transition-duration: 2s;
        color: $dark-grey;
      }
      &.open {
        .fas {
          color: white;
        }
      }
    }
  }
}
</style>